module.exports = __webpack_public_path__ + "assets/img/30_712.de35d100.jpg";